
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { GlassCard } from "@/components/ui/glass-card";
import { recordVoteTime } from "@/components/pwa/install-prompt";
import { useEffect } from "react";

interface DemoVoteSuccessProps {
  onReset: () => void;
  teamName?: string;
}

export function DemoVoteSuccess({ onReset, teamName }: DemoVoteSuccessProps) {
  useEffect(() => {
    // Record vote time with team name to potentially trigger the PWA prompt
    if (teamName) {
      // For demo, just use the homepage URL
      recordVoteTime(teamName, window.location.origin);
    } else {
      recordVoteTime("Demo Team", window.location.origin);
    }
  }, [teamName]);

  return (
    <GlassCard className="text-center p-4">
      <CheckCircle2 className="mx-auto h-8 w-8 text-green-500 mb-3" />
      <h3 className="text-lg font-bold mb-2">Thanks for voting!</h3>
      <p className="text-muted-foreground mb-4">Your votes have been recorded</p>
      <Button onClick={onReset} size="sm">Vote Again</Button>
    </GlassCard>
  );
}
